import './PreparingMealPlan.css'
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import LinearProgress from '@mui/material/LinearProgress';

function PreparingMealPlan() {

    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 100) {
                    return 0;
                }
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 100);
            });
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, []);


    return (
        <div className='preparing_meal_plan_div flex align_center justify_center '>
            <div className='width_100 flex align_center justify_center'>
                <div className='flex flex_column align_center justify_center'>
                    <div className='flex flex_column align_center justify_center gap_20'>
                        <img className='preparing_meal_plan_img' src={'https://png.pngtree.com/png-vector/20220705/ourmid/pngtree-food-logo-png-image_5687686.png'} />
                        <p className='text_align_center font_size_18 font_weight_500'>Preparing Your Meal Plan</p>
                    </div>
                    <div className='preparing_meal_plan_bar'>
                        <LinearProgress variant="indeterminate" color='inherit' value={progress} sx={{ height: 10, borderRadius: '10px' }} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PreparingMealPlan;